module.exports = __webpack_public_path__ + "static/media/Anfora_Arbol_De_Vida.f907838c.png";